<template>
  <div>
    <Breadcrumb :options="breadcrumb" />

    <SearchField :form="formInline" :formCtrl="formCtrl" @onSearch="onSearch" @onReset="onReset"
      @onChange="onSearchItemChange">
      <template #beforeBtn>
        <!-- 复合日期搜索框 -->
        <CompositeFormDate ref="comFormDate" :type="'daterange'" :options="searchDateOptions"
          @onChange="onComSelectSearchChange">
        </CompositeFormDate>
        <!-- 复合搜索框 -->
        <CompositeFormCtrl ref="comFormCtrl" :options="searchKeyOptions" @onChange="onComSearchChange">
        </CompositeFormCtrl>
      </template>
    </SearchField>

    <Table ref="table" :tableData="tableData" :cols="cols" :page="page" :limit="limit" :total="total"
      @onSelectionChange="onSelectionChange" @onCurrentChange="onCurrentChange" @onSizeChange="onSizeChange">
      <template #type="params">
        <span v-if="params.params.type == 1">普通运单</span>
        <span v-if="params.params.type == 2">合同运单</span>
        <!-- <span v-else>合同运单</span> -->
      </template>
      <template #btns="params">
        <Btn :config="btns[0]" :data="params.params" />
        <Btn :config="btns[1]" :data="params.params" v-show="params.params.ischeck == 1" />
      </template>
    </Table>
  </div>
</template>

<script>
import tableMixin from "../../mixin/table";

export default {
  name: "MakeupList",
  mixins: [tableMixin],
  data() {
    return {
      baseUrl: 'order',
      getListUrl: 'recycle',
      breadcrumb: [
        { name: "运单管理" },
        { name: "运单回收站" },
      ],
      formCtrl: [
        {
          label: "运单类型",
          keyName: "type",
          placeholder: "请选择运单类型",
          type: "select",
          options: [
            { label: '全部', value: null },
            { label: '普通运单', value: 1 },
            { label: '合同运单', value: 2 },
          ],
        },
      ],
      curSearchKey: 'shname',
      curSearchValue: undefined,
      searchDateOptions: [
        { label: "装货日期", keyName: "predict_loading_date", },
        { label: "卸货日期", keyName: "predict_unloading_date", },
      ],
      searchKeyOptions: [
        { label: '车牌号', value: 'license', },
        { label: '运单编号', value: 'order_num', },
        { label: '客户名称', value: 'shname', },
      ],
      cols: [
        { keyName: "order_num", label: "运单编号", minwidth: 150 },
        // { keyName: "type", label: "运单类型", slot: 'type' },
        { keyName: "license", label: "车牌号", minwidth: 120 },
        { keyName: "driver", label: "司机姓名", minwidth: 110 },
        { keyName: "name", label: "货物名称", minwidth: 110 },
        { keyName: "shname", label: "客户名称", minwidth: 120 },
        { keyName: "coaddress", label: "装货地址", minwidth: 120 },
        { keyName: "enaddress", label: "卸货地址", minwidth: 120 },
        { ...this.ctrls.ZhuangHuoRiQi, minwidth: 120 },
        { ...this.ctrls.XieHuoRiQi, minwidth: 120 },
        { keyName: "del_name", label: "删除人", width: 120 },
        { keyName: "del_desc", label: "删除原因", width: 120 },
        { keyName: "del_time", label: "删除时间", width: 120 },
        { keyName: "", label: "操作", fixed: 'right', slot: 'btns', minwidth: 100 },
      ],
      btns: [
        {
          ...this.viewBtn,
          cb: ({ id }) => {
            this.$router.push(
              `/order/recycleview?id=${id}&mode=view`
            );
          },
        },
        {
          ...this.feeBtn,
          cb: ({ id }) => {
            this.$router.push(
              `/order/recyclefee?id=${id}&mode=view`
            );
          },
        },
      ],
    };
  },
  methods: {},
  mounted() { },
};
</script>

<style lang="less" scoped></style>
